export default __webpack_public_path__ + "static/media/Step5-Lovrican.1d68fe7b.svg";